import React from "react";

import { IStickyNavItem } from "../../../../Models/IStickyNavItem";
import { colorNine } from "../../../../globalStyles";
import ReportStickyNav from "../../../Common/ReportComponents/ReportStickyNav";

interface RetailMatchStickyNavProps {
  stuckClass: string;
  isSharing?: boolean;
  isScout?: boolean;
}
const navItems = (isSharing?: boolean, isScout?: boolean) : IStickyNavItem[] => {
    const standardOffset = (isSharing || !isScout) ? -50: -110;
    return [
        {
            toComponent: "RMIntroSeg",
            title: "Introduction",
            offset: -500,
            color: colorNine,
        },
        {
            toComponent: "RMKeyMetrics",
            title: "Key Metrics",
            offset: standardOffset,
            color: colorNine,
        },
        {
            toComponent: "RMLocationsAnalyzed",
            title: "Locations Analyzed",
            offset: standardOffset,
            color: colorNine,
        },
        {
            toComponent: "RMPotentialCustomerSimilarity",
            title: "Psychographic Profile",
            offset: standardOffset,
            color: colorNine,
        },
        {
            toComponent: "RMHouseholdComposition",
            title: "Household Composition",
            offset: standardOffset,
            color: colorNine,
        },
    ];
};

export const RetailMatchStickyNav = (props: RetailMatchStickyNavProps): JSX.Element => {
    return (
        <ReportStickyNav
            id="RetailMatchingStickyNav"
            containerId="RetailMatchReportBody"
            stuckClass={props.stuckClass}
            stickyNavItems={navItems(props.isSharing, props.isScout)}
        />
    );
};
